import db from '../firebase-config';

export const WIP_TRACKING_COLLECTION = 'prod_wip_tracking';

export const buildWipLowCareDocumentId = ({ plantId, factory }) => (
  `${plantId}${factory}low_care`
);

const expandDocument = (snapshot) => {
  const data = snapshot.data() || {};
  const typedCollections = [
    ['RAW MAT', data.raw_mat || data.raw_material || data.raw_materials],
    ['WIP', data.wip || data.wip_items],
    ['FG', data.fg || data.finished_goods],
  ];
  const typedItems = typedCollections.flatMap(([category, items]) => (
    Array.isArray(items) ? items.map((item) => ({ ...item, category: item.category || category })) : []
  ));
  const genericItems = data.items || data.stock_items || data.stock;
  const nestedItems = typedCollections.some(([, items]) => Array.isArray(items)) ? typedItems : genericItems;

  if (Array.isArray(nestedItems)) {
    return nestedItems.map((item, index) => ({
      ...data,
      ...item,
      id: item.id || `${snapshot.id}-${index}`,
      firestore_document_id: snapshot.id,
    }));
  }

  return [{ ...data, id: data.id || snapshot.id, firestore_document_id: snapshot.id }];
};

export const subscribeWipTrackingStock = ({ scope, onData, onError }) => {
  const documentId = buildWipLowCareDocumentId(scope);
  return db.collection(WIP_TRACKING_COLLECTION).doc(documentId).onSnapshot(
    (snapshot) => onData(snapshot.exists ? expandDocument(snapshot) : []),
    onError,
  );
};

